function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".a{stroke:rgba(0,0,0,0);stroke-miterlimit:10;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0.502 0.5)"
},
/*#__PURE__*/
React.createElement("path", {
  className: "a",
  d: "M-6038.948,15a1.052,1.052,0,0,1-.793-.353,1.083,1.083,0,0,1-.249-.855l1.642-11.173A2.038,2.038,0,0,1-6036.385.9h1.958V-.573A4.431,4.431,0,0,1-6030-5a4.431,4.431,0,0,1,4.426,4.426q0,.018,0,.037V.9h2.013a2.01,2.01,0,0,1,1.93,1.733l1.6,11.148a1.014,1.014,0,0,1-.179.849A.993.993,0,0,1-6021,15Zm1.573-12.237-1.642,11.166A.1.1,0,0,0-6039,14a.063.063,0,0,0,.053.018H-6021c.012.011.015,0,.009-.029s-.006-.03-.009-.047l-1.608-11.176a1.016,1.016,0,0,0-.955-.879h-2.012V4.292a1.149,1.149,0,0,1,.655,1.037,1.148,1.148,0,0,1-1.146,1.147,1.149,1.149,0,0,1-1.149-1.147,1.15,1.15,0,0,1,.656-1.036V1.886h-6.884V4.292a1.149,1.149,0,0,1,.655,1.037,1.147,1.147,0,0,1-1.146,1.147,1.149,1.149,0,0,1-1.149-1.147,1.149,1.149,0,0,1,.656-1.036V1.886h-1.958A1.062,1.062,0,0,0-6037.375,2.763Zm11.145,2.565a.164.164,0,0,0,.166.164.163.163,0,0,0,.162-.164.164.164,0,0,0-.162-.164A.165.165,0,0,0-6026.23,5.328Zm-7.869,0a.164.164,0,0,0,.165.164.163.163,0,0,0,.163-.164.164.164,0,0,0-.163-.164A.165.165,0,0,0-6034.1,5.328Zm7.54-4.426V-.573A3.446,3.446,0,0,0-6030-4.015a3.446,3.446,0,0,0-3.442,3.442V.9Z",
  transform: "translate(6040 4.999)"
}));

var SvgBagIcon = function SvgBagIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 21.004,
      height: 21,
      viewBox: "0 0 21.004 21",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgBagIcon, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/BagIcon.4221109a.svg";
export { ForwardRef as ReactComponent };